(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paws-collection-tabs')) {
    customElements.define('paws-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const preview = event.target.closest('[data-image-preview]');
          if (preview) {
            const active = preview.getAttribute('aria-pressed') !== 'true';
            preview.setAttribute('aria-pressed', String(active));
            preview.closest('.paws-shop__media').classList.toggle('is-previewing', active);
            preview.querySelector('[data-preview-label]').textContent = active
              ? 'View first image' : 'View second image';
            preview.setAttribute('aria-label',
              `Show ${active ? 'first' : 'second'} image of ${preview.dataset.productTitle}`);
            return;
          }

          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(this.tabs.indexOf(tab));

          const arrow = event.target.closest('[data-direction]');
          if (arrow) this.move(Number(arrow.dataset.direction));
        }, options);

        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;

          const index = this.tabs.indexOf(tab);
          let next;

          if (event.key === 'ArrowRight') {
            next = (index + 1) % this.tabs.length;
          }
          if (event.key === 'ArrowLeft') {
            next = (index - 1 + this.tabs.length) % this.tabs.length;
          }
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;

          if (next !== undefined) {
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }
        }, options);

        this.addEventListener('change', event => {
          if (!event.target.matches('.paws-shop__variant')) return;

          const option = event.target.selectedOptions[0];
          const card = event.target.closest('.paws-shop__card');

          card.querySelector('[data-price]').textContent = option.dataset.price;

          const compare = card.querySelector('[data-compare]');
          compare.textContent = option.dataset.compare;
          compare.hidden = !option.dataset.compare;

          const button = card.querySelector('[type="submit"]');
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
        }, options);

        this.addEventListener('submit', event => {
          if (!event.target.matches('.paws-shop__form')) return;
          event.preventDefault();
          this.addToCart(event.target);
        }, options);

        document.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(
            tab => tab.id.endsWith('-' + event.detail.blockId)
          );
          if (index >= 0) this.select(index);
        }, options);

        this.select(0);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      select(index) {
        if (!this.tabs[index]) return;

        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });

        this.track = this.panels[index].querySelector('.paws-shop__track');
        this.track.scrollLeft = 0;

        const count = this.track.querySelectorAll('.paws-shop__item').length;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.disabled = count < 2;
        });
      }

      move(direction) {
        if (!this.track) return;
        const item = this.track.querySelector('.paws-shop__item');
        if (!item) return;

        const max = this.track.scrollWidth - this.track.clientWidth;
        const step = item.getBoundingClientRect().width
          + parseFloat(getComputedStyle(this.track).gap);

        let next = this.track.scrollLeft + direction * step;
        if (direction > 0 && this.track.scrollLeft >= max - 3) next = 0;
        if (direction < 0 && this.track.scrollLeft <= 3) next = max;

        this.track.scrollTo({
          left: Math.max(0, Math.min(max, next)),
          behavior: this.reduced.matches ? 'instant' : 'smooth'
        });
      }

      async addToCart(form) {
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('.paws-shop__status');
        if (button.disabled) return;

        button.disabled = true;
        button.textContent = 'Adding…';
        status.textContent = '';

        const variantSelect = form.querySelector('select');
        if (variantSelect) variantSelect.disabled = true;

        const cart = document.querySelector('cart-drawer')
          || document.querySelector('cart-notification');
        const data = new FormData(form);

        // Disabled selects are omitted from FormData.
        if (variantSelect) data.set('id', variantSelect.value);

        if (cart?.getSectionsToRender) {
          data.set(
            'sections',
            cart.getSectionsToRender().map(section => section.id).join(',')
          );
          data.set('sections_url', window.location.pathname);
          cart.setActiveElement?.(button);
        }

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: data
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description
              || result.message
              || 'Unable to add this item. Please try again.'
            );
          }

          if (cart?.renderContents && result.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
            status.textContent = 'Added to cart.';

            if (
              typeof publish === 'function'
              && typeof PUB_SUB_EVENTS !== 'undefined'
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'paws-collection-tabs',
                productVariantId: data.get('id'),
                cartData: result
              });
            }
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          status.textContent = error.message
            || 'Unable to add this item. Please try again.';
        } finally {
          if (variantSelect) variantSelect.disabled = false;
          button.disabled = false;
          button.textContent = 'Add to cart';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featuredproduct"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paws-vitality-pack-feature')) {
    customElements.define('paws-vitality-pack-feature', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.querySelectorAll('[data-item]').forEach(button => {
          button.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') this.selectItem(button.dataset.item);
          }, options);

          button.addEventListener('click', () => {
            this.selectItem(button.dataset.item);
          }, options);

          button.addEventListener('focus', () => {
            this.selectItem(button.dataset.item);
          }, options);
        });

        document.addEventListener('shopify:block:select', event => {
          if (this.querySelector('[data-panel="' + event.detail.blockId + '"]')) {
            this.selectItem(event.detail.blockId);
          }
        }, options);

        this.form = this.querySelector('.paws-vitality__form');
        if (!this.form) return;

        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.button = this.form.querySelector('[type="submit"]');
        this.buttonLabel = this.dataset.buttonLabel || 'Add to cart';

        this.updatePackImages();

        this.form.addEventListener('change', event => {
          if (event.target.matches('[type="radio"]')) this.updateVariant();
        }, options);

        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.addToCart();
        }, options);
      }

      selectItem(id) {
        this.querySelectorAll('[data-item]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.item === id));
        });

        this.querySelectorAll('[data-panel]').forEach(panel => {
          panel.hidden = panel.dataset.panel !== id;
        });
      }

      updatePackImages() {
        const optionName = (this.dataset.packOptionName || 'Size').trim().toLowerCase();

        const field = [...this.form.querySelectorAll('fieldset')].find(field =>
          field.querySelector('legend')?.textContent.trim().toLowerCase() === optionName
        );

        const value = field?.querySelector('input:checked')?.value || '';
        const match = value.match(/^\s*([123])\s*pack\b/i);
        const pack = match ? match[1] : null;

        this.querySelectorAll('[data-panel]').forEach(panel => {
          const images = [...panel.querySelectorAll('[data-pack-image]')];
          const chosen = images.find(image => image.dataset.packImage === pack)
            || images.find(image => image.dataset.packImage === 'default');

          images.forEach(image => {
            image.hidden = image !== chosen;
          });
        });
      }

      updateVariant() {
        const selected = [...this.form.querySelectorAll('fieldset')].map(
          field => field.querySelector('input:checked')?.value
        );

        const variant = this.variants.find(variant =>
          variant.options.every((value, index) => value === selected[index])
        );

        this.updatePackImages();
        this.form.querySelector('[data-variant-id]').value = variant?.id || '';
        this.button.disabled = !variant?.available;
        this.button.textContent = !variant
          ? 'Unavailable'
          : variant.available ? this.buttonLabel : 'Sold out';

        this.querySelector('[data-price]').textContent = variant?.price || '';

        const compare = this.querySelector('[data-compare]');
        compare.textContent = variant?.compare || '';
        compare.hidden = !variant?.compare;

        if (variant) {
          const quantity = this.form.querySelector('[name="quantity"]');
          quantity.min = variant.min;
          quantity.step = variant.step;
          if (variant.max) quantity.max = variant.max;
          else quantity.removeAttribute('max');
          quantity.value = variant.min;
        }

        this.form.querySelector('.paws-vitality__status').textContent = '';
      }

      async addToCart() {
        if (this.button.disabled) return;

        const status = this.form.querySelector('.paws-vitality__status');
        const data = new FormData(this.form);
        const fields = [...this.form.querySelectorAll('fieldset')];
        const quantity = this.form.querySelector('[name="quantity"]');

        this.button.disabled = true;
        this.button.textContent = 'Adding…';
        status.textContent = '';
        fields.forEach(field => field.disabled = true);
        quantity.disabled = true;

        const cart = document.querySelector('cart-drawer')
          || document.querySelector('cart-notification');

        try {
          if (cart?.getSectionsToRender) {
            data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
            data.set('sections_url', window.location.pathname);
            cart.setActiveElement?.(this.button);
          }

          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: data
          });

          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add this item.');
          }

          if (cart?.renderContents && result.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
            status.textContent = 'Added to cart.';

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'paws-vitality-feature',
                productVariantId: data.get('id'),
                cartData: result
              });
            }
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          status.textContent = error.message || 'Please try again.';
        } finally {
          fields.forEach(field => field.disabled = false);
          quantity.disabled = false;
          this.button.disabled = false;
          this.button.textContent = this.buttonLabel;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-tab"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paws-reviews-expandable')) {
    customElements.define('paws-reviews-expandable', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const options = { signal };

        this.track = this.querySelector('.pr-track');
        this.items = [...this.querySelectorAll('.pr-item')];
        this.previous = this.querySelector('[data-step="-1"]');
        this.next = this.querySelector('[data-step="1"]');
        this.counter = this.querySelector('.pr-counter');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const toggle = event.target.closest('.pr-toggle');

          if (toggle) {
            const tile = toggle.closest('.pr-tile');
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';

            tile.classList.toggle('is-expanded', expanded);
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.setAttribute(
              'aria-label',
              expanded ? 'Collapse review' : 'Read full review'
            );
            toggle.textContent = expanded ? 'Read less' : '…';

            this.scheduleUpdate();
            return;
          }

          const arrow = event.target.closest('[data-step]');
          if (!arrow || arrow.disabled || !this.items.length) return;

          const step = this.items[0].getBoundingClientRect().width
            + parseFloat(getComputedStyle(this.track).gap);

          this.track.scrollBy({
            left: Number(arrow.dataset.step) * step,
            behavior: this.motion.matches ? 'instant' : 'smooth'
          });
        }, options);

        this.track.addEventListener('scroll', () => {
          this.updateNavigation();
        }, { ...options, passive: true });

        document.addEventListener('shopify:block:select', event => {
          const item = this.items.find(
            item => item.dataset.reviewBlock === event.detail.blockId
          );
          if (!item) return;

          const itemRect = item.getBoundingClientRect();
          const trackRect = this.track.getBoundingClientRect();

          this.track.scrollTo({
            left: this.track.scrollLeft + itemRect.left - trackRect.left,
            behavior: 'instant'
          });
        }, options);

        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);

        this.querySelectorAll('.pr-review-area, .pr-customer').forEach(area => {
          this.observer.observe(area);
        });

        this.querySelectorAll('.pr-product-icon img').forEach(image => {
          image.addEventListener('load', () => this.scheduleUpdate(), options);
        });

        this.scheduleUpdate();

        document.fonts?.ready.then(() => {
          if (!this.isConnected || signal.aborted) return;
          this.scheduleUpdate();
        });
      }

      scheduleUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.measureReviews();
          this.updateNavigation();
        });
      }

      measureReviews() {
        this.querySelectorAll('.pr-tile').forEach(tile => {
          const quote = tile.querySelector('.pr-quote');

          if (tile.classList.contains('is-expanded')) {
            quote.querySelectorAll('a').forEach(link => {
              link.removeAttribute('tabindex');
            });
            return;
          }

          const area = tile.querySelector('.pr-review-area');
          const toggle = tile.querySelector('.pr-toggle');
          const lineHeight = parseFloat(getComputedStyle(quote).lineHeight);
          const availableHeight = area.clientHeight;

          if (!availableHeight || !lineHeight) return;

          const visibleHeight = Math.floor(
            availableHeight / lineHeight
          ) * lineHeight;

          quote.style.maxHeight = visibleHeight + 'px';

          const overflows = quote.scrollHeight > quote.clientHeight + 2;
          toggle.hidden = !overflows;

          quote.querySelectorAll('a').forEach(link => {
            if (overflows) {
              link.setAttribute('tabindex', '-1');
            } else {
              link.removeAttribute('tabindex');
            }
          });
        });
      }

      updateNavigation() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const left = this.track.scrollLeft;

        this.previous.disabled = left <= 3;
        this.next.disabled = maximum <= 3 || left >= maximum - 3;

        if (!this.items.length) {
          this.counter.textContent = '';
          return;
        }

        const viewport = this.track.getBoundingClientRect();
        const visible = this.items
          .map((item, index) => ({
            rect: item.getBoundingClientRect(),
            index
          }))
          .filter(item =>
            item.rect.right > viewport.left + 5
            && item.rect.left < viewport.right - 5
          );

        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;

          this.counter.textContent =
            (first === last ? String(first) : first + '–' + last)
            + ' / ' + this.items.length;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-stackedphoto-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paws-photo-stack')) {
    customElements.define('paws-photo-stack', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.controller = new AbortController();

        const options = { signal: this.controller.signal };
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.stage = this.querySelector('.paws-photo-stack__stage');
        this.counter = this.querySelector('[data-counter]');
        this.controls = [...this.querySelectorAll('.paws-photo-stack__arrow')];
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.busy = false;
        this.pointerStart = null;

        this.cards.forEach(card => {
          card.classList.remove('is-leaving', 'is-leaving-back');
        });
        this.render();

        this.querySelector('[data-next]')?.addEventListener('click', () => {
          this.move(1);
        }, options);

        this.querySelector('[data-previous]')?.addEventListener('click', () => {
          this.move(-1);
        }, options);

        this.stage.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
        }, options);

        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pointerStart = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY
          };
        }, options);

        window.addEventListener('pointerup', event => {
          const start = this.pointerStart;
          this.pointerStart = null;
          if (!start || start.id !== event.pointerId) return;

          const x = event.clientX - start.x;
          const y = event.clientY - start.y;

          if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.3) {
            this.move(x < 0 ? 1 : -1);
          }
        }, options);

        window.addEventListener('pointercancel', () => {
          this.pointerStart = null;
        }, options);

        this.stage.addEventListener('dragstart', event => {
          event.preventDefault();
        }, options);

        document.addEventListener('shopify:block:select', event => {
          const selected = this.cards.findIndex(card =>
            card.id === event.detail.blockId
            || card.dataset.shopifyEditorBlock?.includes(event.detail.blockId)
          );

          if (selected < 0) return;

          clearTimeout(this.timer);
          this.cards.forEach(card => {
            card.classList.remove('is-leaving', 'is-leaving-back');
          });
          this.busy = false;
          this.index = selected;
          this.render();
        }, options);
      }

      render() {
        const count = this.cards.length;

        this.cards.forEach((card, index) => {
          const position = (index - this.index + count) % count;
          card.dataset.position = position < 3 ? String(position) : 'hidden';
          card.setAttribute('aria-hidden', String(position !== 0));
        });

        if (this.counter) {
          this.counter.textContent = `${this.index + 1} / ${count}`;
        }

        this.controls.forEach(button => {
          button.disabled = this.busy || count < 2;
        });
      }

      move(direction) {
        if (this.busy || this.cards.length < 2) return;

        if (this.reduced.matches) {
          this.index = (
            this.index + direction + this.cards.length
          ) % this.cards.length;
          this.render();
          return;
        }

        this.busy = true;
        const departing = this.cards[this.index];
        const leavingClass = direction > 0
          ? 'is-leaving'
          : 'is-leaving-back';

        departing.classList.add(leavingClass);
        this.index = (
          this.index + direction + this.cards.length
        ) % this.cards.length;
        this.render();

        this.timer = setTimeout(() => {
          departing.classList.remove(leavingClass);
          this.busy = false;
          this.render();
        }, 650);
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
